import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import { useProjectState } from "../../../context/stateContext";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import TablesInfoMainTable from "../../../components/User/TablesInfoComponents/TablesInfoMainTable";
import TableInfoActions from "../../../components/User/TablesInfoComponents/TableInfoActions";

const { getRestaurants } = appActions;

export default function TablesInfo() {
  const { selectedOrganization } = useProjectState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <div>
      <PageHeader text="Справка по маси" date={true} />
      <TableInfoActions />
      <TablesInfoMainTable />
    </div>
  );
}
